import Styled from "./Styled";

export default Styled;
